import React from 'react';
import { makeStyles, Typography } from '@material-ui/core';
import { CRM_COLORS } from '../../theme/crmColors';

const useStyles = makeStyles(() => ({
    root: {
        color: CRM_COLORS.secondary,
        fontWeight: 700,
        fontSize: '1.5rem',
        letterSpacing: '-0.015em',
    },
}));

type TypographyFormTitleProps = {
    title: string;
    noWrap?: boolean;
    color: 'initial' | 'inherit' | 'primary' | 'secondary' | 'textPrimary' | 'textSecondary' | 'error';
};

const TypographyFormTitle = ({ title, noWrap, color }: TypographyFormTitleProps) => {
    const classes = useStyles();

    return (
        <Typography classes={{ root: classes.root }} noWrap={noWrap ? noWrap : false} color={color} variant={'button'}>
            {title}
        </Typography>
    );
};

export default TypographyFormTitle;
